import GetTrending from "./GetTrending";
import WithDraw from "./WithDraw";

const repositories = {
  getTrending: GetTrending,
  setWithdraw: WithDraw
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
